import { MarketCountryCode } from '@axo/shared/types';
import { Brand } from '@axo/config/@types/Brand.types';
import { loan_application } from '@axo/shared/data-access/types';
import { useContext } from 'react';
import { DataAccessContext } from '@axo/shared/data-access/provider';

// This is for retrocompatibility with application that don't have a brand specified
const defaultBrands: Record<MarketCountryCode, Brand | undefined> = {
  [MarketCountryCode.Finland]: 'axolaina.fi',
  [MarketCountryCode.Denmark]: 'lendme.dk',
  [MarketCountryCode.Norway]: 'axofinans.no',
  [MarketCountryCode.Sweden]: 'axofinans.se',
};

export function useGetApplicationFormHref(
  marketCountry: string,
  magicToken: string | null | undefined,
  product: loan_application.Product,
  brand?: string,
) {
  const {
    state: {
      user: { clientID },
    },
  } = useContext(DataAccessContext);

  if (!brand) {
    brand = defaultBrands[marketCountry as MarketCountryCode];
  }

  const base =
    product === loan_application.Product.SecuredLoan
      ? import.meta.env.VITE_APP_SECURED_FORM_BASE_URL
      : import.meta.env.VITE_APP_FORM_BASE_URL;

  const formUrl = brand ? `https://${brand}.${base}` : undefined;

  const searchParams = new URLSearchParams();
  if (magicToken) {
    searchParams.append('token', magicToken);
  }

  if (product === loan_application.Product.SecuredLoan) {
    searchParams.append('page', '2');
  }

  searchParams.append('utm_source', 'ace');
  searchParams.append('utm_medium', 'ace');
  searchParams.append('utm_campaign', 'ace');
  searchParams.append('traffic', 'internal');
  if (clientID) {
    searchParams.append('internal_client_id', clientID);
  }

  return formUrl ? `${formUrl}?${searchParams}` : '';
}
